import { StyledLoading } from "./styles";

export function LoadingSpinner() {
  return <StyledLoading />;
}
